module.exports = __webpack_public_path__ + "static/media/icon-unadmin-review.0129f33c.svg";